import React from "react"

import { styled } from "@mui/material/styles"

import { Button } from "./index"

const defaultColor = "info"

export const TextButton: typeof Button = (props) => <StyledTextButton color={defaultColor} variant="text" {...props} />

const StyledTextButton = styled(Button)(({ color = defaultColor, theme }) => ({
  "&[class*='MuiButton-text']": {
    color: theme.palette[color].main,

    "&:hover, &:active": {
      backgroundColor: "transparent", color: theme.palette[color].dark,
    }
  },
}))
